var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComputer = function SvgComputer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#5C068C"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.653,
    height: 11.094,
    x: 2.385,
    y: 0.457,
    strokeWidth: 0.914,
    rx: 0.457
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.457,
    d: "M1.928 13.627h19.495"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 0.914,
    d: "M1 13.394h8.355M13.068 13.394h8.356"
  }))));
};
export default SvgComputer;